<div *ngIf="campaign" class="loader-wrapper">
  <form #landingPageForm="ngForm" [hidden]="isLoading">
    <section class="landing-page">
      <h1 class="landing-page__title">
        {{ "brand.campaign.landingPage.title" | translate }}
        <app-tooltip
          text="{{ 'brand.campaign.landingPage.titleToolTip' | translate }}"
        ></app-tooltip>
      </h1>
      <p class="">{{ "brand.campaign.landingPage.subtitle" | translate }}</p>
      <mat-radio-group
        class="link-type"
        name="promoAdsEnabled"
        [(ngModel)]="campaign.landingPageLinkType"
        [disabled]="!campaign.isEditable"
      >
        <mat-radio-button
          [value]="LinkType.CreatedLandingPage"
          [disabled]="isOptionDisabled(LinkType.CreatedLandingPage)"
          >{{
            "brand.campaign.landingPage.createdLandingPageOption" | translate
          }}</mat-radio-button
        >
        <mat-form-field
          *ngIf="
            campaign.landingPageLinkType === LinkType.CreatedLandingPage &&
            availableLandingPages
          "
          class="landing-page__selector"
        >
          <mat-label>{{
            "brand.campaign.landingPage.createdLandingPageOptionPlaceholder"
              | translate
          }}</mat-label>
          <mat-select
            name="landingPageId"
            [(ngModel)]="campaign.landingPageId"
            [disabled]="
              availableLandingPages?.size === 0 || !campaign.isEditable
            "
          >
            <mat-option
              *ngFor="let lp of availableLandingPages.values"
              [value]="lp.id"
            >
              {{ lp.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-radio-button
          [value]="LinkType.IndividualLandingPage"
          [disabled]="isOptionDisabled(LinkType.IndividualLandingPage)"
          >{{
            "brand.campaign.landingPage.individualOption" | translate
          }}</mat-radio-button
        >
        <mat-radio-button
          [value]="LinkType.RetailerOwnLink"
          [disabled]="isOptionDisabled(LinkType.RetailerOwnLink)"
          >{{
            "brand.campaign.landingPage.ownLinkOption" | translate
          }}</mat-radio-button
        >
        <mat-radio-button
          [value]="LinkType.OneSingleLink"
          [disabled]="isOptionDisabled(LinkType.OneSingleLink)"
          >{{
            "brand.campaign.landingPage.singleLinkOption" | translate
          }}</mat-radio-button
        >
        <div
          class="landing-page-link"
          *ngIf="campaign.landingPageLinkType === LinkType.OneSingleLink"
        >
          <h3>
            {{ "brand.campaign.landingPage.linkTitle" | translate }}
            <app-tooltip
              text="{{ 'brand.campaign.landingPage.linkToolTip' | translate }}"
            ></app-tooltip>
          </h3>
          <div class="row no-wrap">
            <div class="col width-auto no-padding-right">
              <mat-form-field class="link-prefix">
                <mat-select
                  [(ngModel)]="campaign.landingPageLinkPrefix"
                  name="landingPageLinkPrefix"
                  required
                >
                  <mat-option
                    *ngFor="let urlPrefix of UrlPrefixes"
                    [value]="urlPrefix"
                  >
                    {{ urlPrefix }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col width-100 no-padding-left">
              <mat-form-field class="landing-page-link">
                <mat-label>{{
                  "brand.campaign.landingPage.linkPlaceholder" | translate
                }}</mat-label>
                <input
                  #landingPageLink
                  matInput
                  (change)="formatLandingPageLinkUrl()"
                  [(ngModel)]="campaign.landingPageLink"
                  name="landingPageLink"
                  type="url"
                  pattern="{{ URL_VALIDATION_PATTERN }}"
                  [required]="
                    campaign.landingPageLinkType === LinkType.OneSingleLink
                  "
                  [disabled]="!campaign.isEditable"
                />
                <mat-error *ngIf="landingPageLinkControl">
                  <span
                    *ngIf="
                      landingPageLinkControl.invalid &&
                      landingPageLinkControl.errors.pattern
                    "
                  >
                    {{ "shared.enterValidUrl" | translate }}
                  </span>
                  <span
                    *ngIf="
                      landingPageLinkControl.invalid &&
                      landingPageLinkControl.errors.required
                    "
                  >
                    {{
                      "brand.campaign.landingPage.landingPageLinkRequired"
                        | translate
                    }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <mat-radio-button
          *ngIf="hasBrandProvidedPartnerUrlFeatureEnabled"
          [value]="LinkType.BrandProvidedPartnerUrl"
          [disabled]="isOptionDisabled(LinkType.BrandProvidedPartnerUrl)"
          >{{
            "brand.campaign.landingPage.brandProvidedPartnerUrl" | translate
          }}</mat-radio-button
        >
      </mat-radio-group>
    </section>
  </form>
  <app-autosave-tooltip [running]="saving" [error]="savingError" />
  <mat-progress-bar *ngIf="isLoading" color="accent" mode="indeterminate" />
</div>
